// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title[data-v-1799ce43] {\n  padding-left: 10px;\n  font-size: 14px;\n}\n.table-container[data-v-1799ce43] {\n  padding-left: 30px;\n}\n.table-title[data-v-1799ce43] {\n  padding-bottom: 10px;\n  font-size: 14px;\n}\n.table-body[data-v-1799ce43] {\n  margin-bottom: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
